import {Method} from "./HttpMethods";

export interface VsoAccount {
  AccountId: string,
  NamespaceId: string,
  AccountName: string,
  OrganizationName: string,
  AccountType: number,
  AccountOwner: string,
  CreatedBy: string,
  CreatedDate: string,
  AccountStatus: 0,
  StatusReason: string,
  LastUpdatedBy: string,
  Properties: {[key:string]: any}
}

const vsoApiRoot = 'https://app.vssps.visualstudio.com/_apis';

export class VsoApi {
  constructor(private token: string) {

  }

  public get accounts() : JQueryPromise<VsoAccount[]> {
    return this.request<VsoAccount[]>(`${vsoApiRoot}/Accounts`, Method.GET);
  }

  private request<T>(url: string, method: Method, data?: any) : JQueryPromise<T> {
    return $.ajax({
      url: url,
      type: Method[method],
      contentType: "application/json",
      dataType: "json",
      headers: {
        Authorization: `token ${this.token}`
      },
      data: data ? JSON.stringify(data) : data
    });
  }
}


// WEBPACK FOOTER //
// ./Client/Services/VsoApi.ts